import actions from './actions';

const {
  GET_ALL_PRODUCTS_BEGIN,
  GET_ALL_PRODUCTS_SUCCESS,
  GET_ALL_PRODUCTS_ERR,

  EDIT_PRODUCT_BEGIN,
  EDIT_PRODUCT_SUCCESS,
  EDIT_PRODUCT_RESET,
  EDIT_PRODUCT_ERR,

  GET_SINGLE_PRODUCT_BEGIN,
  GET_SINGLE_PRODUCT_SUCCESS,
  GET_SINGLE_PRODUCT_ERR,
  GET_SINGLE_PRODUCT_RESET,

  SINGLE_PRODUCT_BEGIN,
  SINGLE_PRODUCT_SUCCESS,
  SINGLE_PRODUCT_ERR,

  FILTER_PRODUCT_BEGIN,
  FILTER_PRODUCT_SUCCESS,
  FILTER_PRODUCT_ERR,

  SORTING_PRODUCT_BEGIN,
  SORTING_PRODUCT_SUCCESS,
  SORTING_PRODUCT_ERR,
} = actions;

const initialStateFilter = {
  data: [],
  loading: false,
  error: null,
};

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const singleProductInitialState = {
  data: {
    product_id: null,
    lang: '',
    title_en: '',
    title_ar: '',
    desc_html_en: '',
    desc_html_ar: '',
    age_min: 0,
    age_max: 0,
    image_repo: '',
    prices: [
      {
        price: 0,
      },
    ],
  },
  loading: false,
  error: null,
  editPrdouct: {
    loading: false,
    data: null,
    error: null,
  },
};

const productReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_ALL_PRODUCTS_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case GET_ALL_PRODUCTS_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };
    case GET_ALL_PRODUCTS_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };
    case FILTER_PRODUCT_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case FILTER_PRODUCT_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };
    case FILTER_PRODUCT_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };
    case SORTING_PRODUCT_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case SORTING_PRODUCT_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };
    case SORTING_PRODUCT_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const SingleProductReducer = (state = singleProductInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_SINGLE_PRODUCT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_SINGLE_PRODUCT_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case GET_SINGLE_PRODUCT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case GET_SINGLE_PRODUCT_RESET:
      return {
        ...state,
        data: singleProductInitialState.data,
        error: null,
        loading: false,
      };
    case EDIT_PRODUCT_BEGIN:
      return {
        ...state,
        editPrdouct: {
          ...state.editPrdouct,
          loading: true,
        },
      };
    case EDIT_PRODUCT_SUCCESS:
      return {
        ...state,
        editPrdouct: {
          ...state.editPrdouct,
          data,
          loading: false,
          error: null,
        },
      };
    case EDIT_PRODUCT_RESET:
      return {
        ...state,
        editPrdouct: {
          ...state.editPrdouct,
          data: null,
          loading: false,
          error: null,
        },
      };
    case EDIT_PRODUCT_ERR:
      return {
        ...state,
        editPrdouct: {
          ...state.editPrdouct,
          loading: false,
          error: err,
        },
      };
    case SINGLE_PRODUCT_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case SINGLE_PRODUCT_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case SINGLE_PRODUCT_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export { SingleProductReducer, productReducer };
